import React from 'react';
import { labelByKey } from '@cm/new-shared-fe/services/labels';
import { getParameter } from '@cm/new-shared-fe/services/parameters';
import { Button, FormWrapper, InfoField } from '@cm/react-components';

export const Confirmation = ({ interests, email, insuranceIsActiveOnDomain = false }) => {
  const goToURL = () => {
    window.location.href = getParameter(insuranceIsActiveOnDomain ? 'confirmation.link.cm' : 'confirmation.link.insurances') || '/';
  };

  return <>
    <InfoField success className="mb-1.5" data-e2e="submit.success.email_sent">
      {labelByKey('confirmation.email.sent.to')} <strong>{email}</strong>
    </InfoField>
    <div className="w-10/12 px-0 ml-form md:w-full md:ml-0 md:px-0">
      <div className="mb-3 block border-b border-dotted border-griege">
        <div className="mb-3">
          {insuranceIsActiveOnDomain && (
            <FormWrapper icon="form-information" label={labelByKey('confirmation.insurance.interests.label')} data-e2e="submit.success.insuranceIsActiveOnDomain">
              {interests.length > 0 && <p>{labelByKey('confirmation.insurance.interests.yes.text', { interests: interests.join(',') })}</p>}
              {!interests.length && <p>{labelByKey('confirmation.insurance.interests.no.text')}</p>}
              <p>{labelByKey('confirmation.insurance.interests.followup')}</p>
            </FormWrapper>
          )}
          {!insuranceIsActiveOnDomain && (
            <FormWrapper icon="form-information" label={labelByKey('confirmation.insurance.interest.label')} data-e2e="submit.success.insuranceIsNotActiveOnDomain">
              <p>{labelByKey('confirmation.insurance.interest.text')}</p>
              <ul className="text-sm mt-2">
                <li>{labelByKey('confirmation.insurance.interest.footnote.1')}</li>
              </ul>
            </FormWrapper>
          )}
        </div>
      </div>
      <div>
        <Button onClick={goToURL} label={labelByKey(insuranceIsActiveOnDomain ? 'link.my-cm' : 'link.insurances')} data-e2e="confirmation.button"/>
      </div>
    </div>
  </>;
};
